import { apiSlice } from "./apiSlice";
import config from "../../config.json";

export const timeLogApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadTimeLogs: builder.query({
      query: (id) => (config.GetTimeLog || "") + id,
      providesTags: ["TimeLogs"],
    }),
    loadTimeLogDuration: builder.query({
      query: (id) => (config.GetCandidateProjectStartDate || "") + id,
      providesTags: ["TimeLogDuration"],
    }),
    loadAllRates: builder.query({
      query: (id) => (config.GetRateHistory || "") + id,
      providesTags: ["AllRates"],
    }),
    loadTimeLogInvoice: builder.query({
      query: (id) => (config.GetTimeLogInvoice || "") + id,
      providesTags: ["TimeLogInvoice"],
    }),
    updateProjectStartDate: builder.mutation({
      query: ({ id, date }) => ({
        url: (config.UpdateProjectStartDate || "") + id + "&startDt=" + date,
        method: "GET",
      }),
      invalidatesTags: ["TimeLogDuration"],
    }),
    deleteTimeSheetDoc: builder.mutation({
      query: (id) => ({
        url: (config.DeleteTimeLogTimeSheetDoc || "") + id,
        method: "DELETE",
      }),
      invalidatesTags: ["TimeLogs"],
    }),
    setTimeLogReportStatus: builder.mutation({
      query: ({ id, updatedBy }) => ({
        url: (config.SetTimeLogStatus || "") + id + (updatedBy ? `?updatedBy=${updatedBy}` : ""),
        method: "PUT",
      }),
      invalidatesTags: ["TimeLogs"],
    }),
    addNewTmLog: builder.mutation({
      query: (data) => ({
        url: config.AddNewTimeLog || "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["TimeLogs"],
    }),
    updateTimeLogInvoice: builder.mutation({
      query: (data) => ({
        url: config.UpdateTimeLogInvoice || "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["TimeLogInvoice"],
    }),
    printGeneratedInvoice: builder.mutation({
      query: (data) => ({
        url: config.PrintTemplate || "Template/Print",
        method: "POST",
        body: data,
        responseHandler: (response) => response.blob(),
      }),
    }),
    timeLogInvDocDeleteReq: builder.mutation({
      query: (id) => ({
        url: (config.RequestDeleteInvoiceDoc || "") + id,
        method: "GET",
      }),
      invalidatesTags: ["TimeLogInvoice"],
    }),
    loadBulkAllRates: builder.query({
      query: (ids) => ({
        url: config.GetRateHistoryBulk || "",
        method: "POST",
        body: ids,
      }),
      providesTags: ["BulkRates"],
    }),
  }),
});

export const {
  useLoadTimeLogsQuery,
  useLazyLoadTimeLogsQuery,
  useLoadTimeLogDurationQuery,
  useLazyLoadTimeLogDurationQuery,
  useLoadAllRatesQuery,
  useLazyLoadAllRatesQuery,
  useLoadTimeLogInvoiceQuery,
  useLazyLoadTimeLogInvoiceQuery,
  useUpdateProjectStartDateMutation,
  useDeleteTimeSheetDocMutation,
  useSetTimeLogReportStatusMutation,
  useAddNewTmLogMutation,
  useUpdateTimeLogInvoiceMutation,
  usePrintGeneratedInvoiceMutation,
  useTimeLogInvDocDeleteReqMutation,
  useLoadBulkAllRatesQuery,
  useLazyLoadBulkAllRatesQuery,
} = timeLogApiSlice;
